import { Box } from '@chakra-ui/react';
import {
  stretchAnimation,
  scaleInAnimation,
} from '@texas/resources/animations/animations';
import React from 'react';

interface Props {
  children: React.ReactNode;
  show: boolean;
}

export function BlueDot({ children, show }: Props) {
  return (
    <Box pos="relative" maxW="fit-content">
      {children}
      {show && (
        <Box pos="absolute" top={-1} right={-1} data-changed="1">
          <Box
            borderRadius="50%"
            backgroundColor="texas.notification.info"
            boxSize={2}
            animation={`${stretchAnimation()},${scaleInAnimation()}`}
          />
        </Box>
      )}
    </Box>
  );
}
